import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import ProjectPage from '../../components/ProjectPage'

const projectElements = {
	images: [
	  {
	    "src": "Stadthimmel/city_1",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Stadthimmel/city_2",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Stadthimmel/city_3",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Stadthimmel/city_4",
	    "orientation": "landscape"
	  }
	]
}

export default class Stadthimmel extends React.Component{
	render(){
		return(
			<ProjectPage 
			title="Stadthimmel" 
			text="Die Fotoserie ist zwei Entwicklungsstufen durchgangen. Beide konzentrierten sich jedoch auf eine oder mehrere Linien.
			Während einem Spaziergang durch die Stadt fielen mir die Kabel der Straßenlampen auf, welche den Blick zum Himmel versperren.
			Die Fotoserie besteht aus vier sich wiederholenden Fotos welche viermal abweichend zusammengestellt wurden um eine verbundene 
			Linie zu ergeben.Im Jahr 2016 haben wir gemeinsam als Klasse eine Ausstellung mit dem Titel  „Borderline“ organisiert. Als Teil 
			ieser Ausstellung ist die Fotoserie „Stadthimmel“ entstanden. Für die einzelnen Werke mussten sich die Künstler für eine 
			Präsentationsform entscheiden. Für meine Aufhängung entschied ich mich für eine große Pinnwand, welche mir die Möglichkeit gab, 
			die Zusammenstellung der Fotos flexibel zu ändern."
			images={projectElements.images}
			layout={'einser'}/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/pages/projects/citysky.js